/* Oakman — coming soon signup.
   Posts through window.oakSubscribe (assets/oak-klaviyo.js, configured by
   snippets/oak-klaviyo.liquid), same as the Founding 100 forms on the film.
   custom_source names the page, so these stay segmentable from footer signups. */
(function(){
  var forms = document.querySelectorAll('.oakcs .csform');
  if(!forms.length) return;
  Array.prototype.forEach.call(forms, function(f){
    var join = f.closest('.csjoin');
    var btn  = f.querySelector('button[type=submit]');
    f.addEventListener('submit', function(e){
      e.preventDefault();
      if(!join) return;
      var input = f.querySelector('input[type=email]');
      var email = input ? String(input.value || '').trim() : '';
      if(!email) return;
      join.classList.remove('err');
      if(btn) btn.disabled = true;
      var go = (typeof window.oakSubscribe === 'function')
        ? window.oakSubscribe(email)
        : Promise.reject(new Error('oakSubscribe missing'));
      go.then(function(){
        join.classList.add('sub');
      }).catch(function(err){
        if(btn) btn.disabled = false;
        join.classList.add('err');
        if(window.console && console.error) console.error('[OAK] signup failed:', err);
      });
    });
  });
})();
